import { render } from "./Newsletter.vue?vue&type=template&id=62b1cce5"
const script = {}

import exportComponent from "/var/www/retail.interapptive.media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__